/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'project-api-keys',
  title: 'Read errors and traces with an API key',
  category: 'SDKs & API',
  summary:
    'Create a read-only project or organization API key and use it from scripts, CI or an AI agent like Claude to query issues, events and traces.',
  keywords: ['API key', 'API token', 'token', 'bearer', 'authorization', 'curl', 'Claude', 'AI agent', 'CI', 'Swagger', 'OpenAPI', 'read-only', 'organization key', 'all projects'],
};

export const loadComponent = () => import('./project-api-keys.component').then((m) => m.ProjectApiKeysArticleComponent);
